import { render, staticRenderFns } from "./ModalChangePassword.vue?vue&type=template&id=76aaed8d&"
import script from "./ModalChangePassword.vue?vue&type=script&lang=js&"
export * from "./ModalChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ModalChangePassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports